import ReactGA from 'react-ga4';

export const initGA = (): void => {
  ReactGA.initialize('G-GNSJ7HSPB0');
};
